<!-- MainHeader.vue -->
<template>
  <header class="bg-white border-bottom py-2 main-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col d-flex justify-content-end align-items-center">
          <!-- Logos auf der rechten Seite -->
          <img src="@/assets/logos/FH_CEFoodCycle_Logo.png" alt="FH CEFoodCycle Logo" class="logo me-2" />
          <img src="@/assets/logos/CEFoodCycle_Interreg.png" alt="CEFoodCycle Interreg Logo" class="logo" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MainHeader'
};
</script>

<style scoped>
.main-header {
  position: sticky;
  top: 0;
  z-index: 1030;
  background-color: white;
}

.logo {
  height: calc(3.5rem + 1vw);
  max-height: 80px;
}

/* Ihre bestehenden Medienabfragen und Styles */
</style>
